export enum MenuState {
    profile = 0,
    language = 1,
    theme = 2,
}
